import React, { useState } from "react";
import { Container, Box, Typography, Paper, Divider } from "@mui/material";
import{ AddContractButton, ContractTable } from "../../components";
import { PageStructure } from "../"

const Contracts = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));

  const refreshContracts = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <PageStructure>
        <Container maxWidth="xl">
            <Paper sx={{ p: 3, mt: 3 }}>
           {
            user.permissions.canAddContract && (
           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                <Typography variant="h4" component="h1">
                Contracts Management
                </Typography>
                <AddContractButton refreshContracts={refreshContracts} />
            </Box>
            )}
            <Divider sx={{ my: 2 }} />
            <ContractTable key={refreshTrigger} />
            </Paper>
        </Container>
    </PageStructure>
   
  );
};

export default Contracts;